/**
 * Directive: scheduleRangeEdit
 */
angular.module('acme.common.directive.scheduleRangeEdit', [
  'acme.common.directive.dayPicker',
  'acme.common.directive.dateTimePicker'
])
.directive('scheduleRangeEdit', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/scheduleRange/edit/edit.tpl.html',
      scope: {
        model: '=',
        label: '@',
        scheduleIndex: '@scheduleindex'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        $scope.$watch('model', $scope.scheduleRangeEdit.onModelUpdate);
      },

      controller: ['$scope', function($scope) {

        $scope.scheduleRangeEdit = {

          model: {},

          endTimeMinutes: '',
          endTimeHours: '',

          startTimeMinutes: '',
          startTimeHours: '',

          init: function() {
          },



          onModelUpdate: function(model) {
            $scope.scheduleRangeEdit.model = model;
          }

        };

        $scope.scheduleRangeEdit.init();

      }]

    };

}]);